const colorRange = [
    // "#bc5148",
    // "#3090a1",
    "#000000"
    // "#6c4343",
    // "#364968",
    // "#ac4c5e",
    // "#5c476f",
    // "#8bbabb"
]

export default colorRange